/* unplugin-vue-components disabled */import { render } from "./viewOnWebsite.vue?vue&type=template&id=e4dfe990&scoped=true"
const script = {}

import "./viewOnWebsite.vue?vue&type=style&index=0&id=e4dfe990&lang=stylus&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/JOINMC-H5-HTML-MASTER/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4dfe990"]])

export default __exports__